export enum CarouselSwipeDirection {
  prev = 'prev',
  next = 'next',
}

const carouselDataLayerSubmit = (action: string, section: string) => {
  window.dataLayer = window.dataLayer || [];
  window.dataLayer.push({
    event: 'carouselNavigation',
    action,
    section,
  });
};

const addCarouselBulletAnalyticEventListeners = (
  bullets: Element[],
  section?: string,
) => {
  const eventListeners: (() => void)[] = [];
  if (section) {
    bullets.forEach((bullet, i) => {
      const eventListener = () => carouselDataLayerSubmit(`bullet slide ${i + 1}`, section);
      eventListeners.push(eventListener);
      bullet.addEventListener('click', eventListener);
    });
  }

  return eventListeners;
};

const removeCarouselBulletAnalyticEventListeners = (
  eventListeners: (() => void)[],
  bullets: Element[],
) => {
  bullets.forEach((bullet, i) => bullet.removeEventListener('click', eventListeners[i]));
};

export const carouselAnalyticsEvents = (section?: string) => {
  if (!section) {
    return {};
  }
  return {
    onNavigationPrev: () => carouselDataLayerSubmit('left arrow', section),
    onNavigationNext: () => carouselDataLayerSubmit('right arrow', section),
    onTouchEnd: (event) => event.swipeDirection
      && carouselDataLayerSubmit(
        event.swipeDirection === CarouselSwipeDirection.prev
          ? 'drag left'
          : 'drag right',
        section,
      ),
  };
};

export const addCarouselBulletAnalyticEvents = (
  sectionTarget: string,
  section?: string,
) => {
  let eventListeners: (() => void)[] = [];
  let bullets: any = [];
  if (document && sectionTarget) {
    bullets = document.querySelectorAll(
      `.${sectionTarget} .swiper-pagination-bullet`,
    );
    eventListeners = addCarouselBulletAnalyticEventListeners(bullets, section);
  }
  return () => {
    if (document && sectionTarget) {
      removeCarouselBulletAnalyticEventListeners(eventListeners, bullets);
    }
  };
};
